import React from 'react';
import CinematicHero from '../components/home/CinematicHero';
import TrustStrip from '../components/home/TrustStrip';
import PillarsSection from '../components/home/PillarsSection';
import ProductTourSection from '../components/home/ProductTourSection';
import AiAccountability from '../components/home/AiAccountability';
import RolesSection from '../components/home/RolesSection';
import FinalCta from '../components/home/FinalCta';
import Reveal from '../components/Reveal';
import SEO from '../components/SEO';
import '../components/home/home.css';

const PAGE_TITLE = 'Phennx - Clinical Research Operations, In One Command Center';
const PAGE_DESCRIPTION =
  'Phennx is a clinical trial management platform that helps sites, sponsors, and CROs coordinate studies, visits, documents, monitoring, payments, and audit-ready workflows — with less operational drift.';

const HOME_SCHEMA = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://phennx.io/#organization',
      name: 'Phennx',
      url: 'https://phennx.io/',
      logo: 'https://phennx.io/logo-full-transparent.png',
      description:
        'Clinical trial management platform for research sites, sponsors, CROs, and monitors — designed for regulated, audit-ready research workflows.',
      foundingDate: '2024',
      sameAs: ['https://www.linkedin.com/company/phennx'],
    },
    {
      '@type': 'WebSite',
      '@id': 'https://phennx.io/#website',
      url: 'https://phennx.io/',
      name: 'Phennx',
      publisher: { '@id': 'https://phennx.io/#organization' },
    },
    {
      '@type': 'WebPage',
      '@id': 'https://phennx.io/#webpage',
      url: 'https://phennx.io/',
      name: PAGE_TITLE,
      description: PAGE_DESCRIPTION,
      isPartOf: { '@id': 'https://phennx.io/#website' },
      about: { '@id': 'https://phennx.io/#organization' },
    },
    {
      '@type': 'SoftwareApplication',
      '@id': 'https://phennx.io/#software',
      name: 'Phennx',
      applicationCategory: 'BusinessApplication',
      operatingSystem: 'Web',
      description:
        'Clinical trial management system covering study startup, visits, documents, eSource forms, monitoring, quality control, audit trails, reporting, finance, and patient stipend payments.',
      publisher: { '@id': 'https://phennx.io/#organization' },
    },
  ],
};

export default function HomePage() {
  return (
    <div className="home">
      <SEO
        title={PAGE_TITLE}
        description={PAGE_DESCRIPTION}
        path="/"
        type="website"
        schema={HOME_SCHEMA}
      />
      <CinematicHero />
      <Reveal>
        <TrustStrip />
      </Reveal>
      <PillarsSection />
      <Reveal>
        <ProductTourSection />
      </Reveal>
      <Reveal>
        <AiAccountability />
      </Reveal>
      <Reveal>
        <RolesSection />
      </Reveal>
      <FinalCta />
    </div>
  );
}
